import styled from "styled-components";

export const Main = styled.div`
   display: flex;
   flex-direction: column;
   justify-content: space-between;
   width: 1000px;
   height: 600px;

   &.external {
      width: 100%;
      height: 100%;
      border-radius: initial !important;

      .setup ul {
         width: 250px;
         min-width: 250px;
         height: calc(100vh - 25.78px - 20px - 60px);
      }
      .content .tabs {
         width: 280px;
         min-width: 280px;
      }
   }
   .close {
      top: 20px;
   }
   .title {
      display: flex;
      align-items: center;

      > div {
         background-color: #F6F6F6;
         border: 1px dashed rgb(200, 200, 200);
         padding: 7.5px 15px;
         border-radius: 5px;
         font-size: 16px;
         color: #777;
         cursor: pointer;
         margin-left: 15px;

         svg {
            margin-right: 7.5px;
         }
         &.active, &:hover {
            text-decoration: underline;
         }
      }
   }
   h3 {
      font-weight: 500;
      margin-bottom: 0 !important;
   }
   .block {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      border-radius: 5px;
      height: 55px;

      span:first-of-type {
         opacity: 0.8;
         text-transform: uppercase;
         font-size: 17px;
      }
      span:last-of-type {
         display: flex;
         align-items: center;
         opacity: 0.5;
         font-size: 16px;

         svg {
            transform: scaleX(-1);
            margin-right: 7.5px;
         }
      }
   }
   .setup {
      display: flex;
      flex-direction: column;
      height: 100%;

      .title {
         margin-bottom: 20px;
      }
      .flex {
         display: flex;
         height: 100%;
      }
      ul {
         width: 200px;
         min-width: 200px;
         overflow: auto;
         height: 483.67px;
         margin-right: 15px;
         
         &::-webkit-scrollbar {
            width: 0;
         }
         .block {
            cursor: move;
            background-color: rgb(243, 244, 246);

            &:not(:last-of-type) {
               margin-bottom: 10px;
            }
            &:hover {
               border: 1px solid #9dbbef;
               background-color: #cee5fd;
            }
         }
         .empty {
            display: flex;
            justify-content: center;
            align-items: center;
            text-align: center;
            height: 100%;
            opacity: 0.5;
         }
      }
      .zone {
         position: relative;
         display: flex;
         flex-direction: column;
         align-items: center;
         justify-content: center;
         border: 1px solid rgb(230, 230, 230);
         padding-left: 15px;
         width: 100%;

         /* .multiple {
            position: relative;
            top: -60px;
            text-align: center;
            
            p {
               margin-bottom: 20px;
               font-size: 25px;
            }
            button {
               color: #fff;
               border: none;
               width: 90px;
               height: 35px;
               font-size: 16px;
               border-radius: 5px;
               padding: 0 15px;
               cursor: pointer;
               transition: all .2s ease-in-out;

               &:first-of-type {
                  background-color: #1E272E;
                  margin-right: 7.5px;
               }
               &:last-of-type {
                  background-color: #F05454;
               }
               &:hover {
                  opacity: 0.85;
               }
            }
         } */
         .block {
            width: 200px;
            background-color: #d7e9fd;

            &:first-of-type {
               margin-bottom: 200px;
            }
            &.focus {
               border: 2px solid #81aaf0;
            }
            .active {
               opacity: 0.8;
               font-size: 17px;
            }
            .empty {
               opacity: 0.4;
            }
         }
         .dataflow {
            position: absolute;
            width: 100%;
            overflow: hidden;
            width: 1px;
            height: 200px;
            border-right: 2px dashed rgba(30, 39, 46, 0.2);
         }
         .start {
            position: absolute;
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: #1E272E;
            color: #fff;
            border: none;
            height: 35px;
            font-size: 15px;
            border-radius: 5px;
            padding: 0 15px;
            cursor: pointer;
            transition: all .2s ease-in-out;

            svg {
               margin-right: 7.5px;
            }
            &:disabled {
               cursor: default;
               opacity: 0.9;

               span, svg {
                  opacity: 0.5;
               }
               &:hover {
                  opacity: 0.9;
               }
            }
            &:hover {
               opacity: 0.85;
            }
         }
      }
   }
   .content {
      display: flex;
      // flex-direction: column;
      height: 100%;

      .tabs {
         width: 250px;
         min-width: 250px;
         margin-right: 20px;
         height: 100%;
         background-color: rgb(243, 244, 246);
         border-radius: 5px 0 0 5px;
         padding: 30px 20px;
         font-size: 16px;

         li {
            display: flex;
            align-items: center;
            cursor: pointer;
            padding: 0 10px;
         }
         .add {
            margin-bottom: 15px;
            transition: opacity .2s ease-in-out;

            span {
               margin-left: 7.5px;
            }
            &:hover {
               opacity: 0.65;
            }
         }
         .item {
            justify-content: space-between;
            height: 35px;
            border-radius: 5px;
            transition: background-color .1s ease-in-out;

            input {
               border: none;
               width: 100%;
               height: calc(100% - 11px);
               font-size: 17px;
               margin-right: 15px;
               border-radius: 5px;
               padding: 0 7.5px;
               box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
               background-color: rgba(255, 255, 255, 0.1);
               color: #fff;
            }
            &.active {
               background-color: #1E272E;
               color: #fff;

               span {
                  opacity: 1;
               }
               &:hover {
                  background-color: #1E272E;
               }
            }
            span {
               opacity: 0.8;
            }
            svg {
               transition: opacity .2s ease-in-out;

               &:hover {
                  opacity: 0.5;
               }
            }
            &:hover {
               background-color: rgba(30, 39, 46, 0.08);
            }
         }
      }
      .chat {
         display: flex;
         flex-direction: column;
         width: 100%;
         height: 100%;
         padding: 30px 30px 30px 10px;
      }
      .messages {
         padding: 20px;
         height: 100%;
         margin: 15px 0;
         border: 1px solid rgba(30, 39, 46, 0.1);
         border-radius: 5px;
         overflow: auto;

         .item {
            display: flex;

            &:not(:last-of-type) {
               margin-bottom: 35px;
            }
            img {
               width: 40px;
               height: 40px;
               object-fit: cover;
               border-radius: 5px;
               margin-right: 15px;
            }
            pre {
               white-space: pre-wrap;

               span:first-of-type {
                  display: block;
                  font-weight: 500;
                  margin-top: -3px;
                  margin-bottom: 2px;
               }
               span:last-of-type {
                  opacity: 0.85;
                  line-height: 1.4;
                  font-size: 17px;
               }
            }
         }
         .empty {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 100%;
            opacity: 0.5;
         }
      }
      .action {
         position: relative;

         textarea {
            padding: 18px 200px 15px 15px;
            background-color: rgb(243, 244, 246);
            border: none;
            width: 100%;
            border-radius: 5px;
            min-height: 55px;
            height: 55px;
            max-height: 140px;
            resize: none;
            font-size: 18px;

            &::-webkit-scrollbar {
               width: 0;
            }
            &::placeholder {
               color: #000;
               opacity: 0.5;
            }
         }
         > div {
            display: flex;
            align-items: center;
            position: absolute;
            bottom: 12px;
            right: 15px;

            .file {
               position: relative;
               display: flex;
               align-items: center;
               margin-right: 15px;
               max-width: 125px;
               height: 30px;
               border-radius: 5px;
               font-size: 15px;
               padding: 0 15px;

               input {
                  position: absolute;
                  left: 0;
                  width: 100%;
                  height: 100%;
                  opacity: 0;
                  z-index: 99;
               }
               svg, span {
                  transition: all .2s ease-in-out;
               }
               svg {
                  margin-right: 7.5px;
               }
               span {
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
               }
               &:hover {
                  svg, span { opacity: 0.75; }
               }
            }
            button {
               display: flex;
               align-items: center;
               justify-content: center;
               color: #fff;
               width: 50px;
               height: 40px;
               font-size: 23px;
               border: none;
               border-radius: 5px;
               background-color: #1E272E;

               &.loading svg {
                  animation: loading 1.1s infinite linear;

                  @keyframes loading  {
                     0% { transform: rotate(0deg); }
                     100% { transform: rotate(360deg); }
                  }
               }
               &:disabled {
                  background-color: #BEC1C4;
               }
            }
         }
      }
   }
`;